module.exports = __webpack_public_path__ + "static/media/time-icon.aceb2362.svg";